import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import store from "./store";

import axios from "axios";
Vue.use({
  install(Vue) {
    Vue.prototype.$api = axios.create({
      baseURL: "https://api.pirls.ir/",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json"
      }
    });
  }
});

import moment from "jalali-moment";
Object.defineProperty(Vue.prototype, "$moment", { value: moment });

// pdf generator
import { jsPDF } from "jspdf";
import "./assets/fonts/iransansdn-normal";
import "jspdf-autotable";
Object.defineProperty(Vue.prototype, "$jspdf", { value: jsPDF });

import FormAlert from "./components/Shared/FormAlert";
Vue.component("form-alert", FormAlert);

import Message from "./components/Shared/Message";
Vue.component("message-alert", Message);

import PersianDate from "./components/Shared/PersianDate";
Vue.component("persian-date", PersianDate);

import Number from "./components/Shared/Number";
Vue.component("number-component", Number);

import VueApexCharts from "vue-apexcharts";
Vue.component("apex-chart", VueApexCharts);

import VueCookies from "vue-cookies";
Vue.use(VueCookies);
Vue.$cookies.config("7d");

import VuePlyr from "vue-plyr";
import "vue-plyr/dist/vue-plyr.css";
Vue.use(VuePlyr, {
  emit: ["ended"]
});

import JsonCSV from "vue-json-csv";
Vue.component("downloadCsv", JsonCSV);

import VueCountdown from "@chenfengyuan/vue-countdown";
Vue.component(VueCountdown.name, VueCountdown);

import VuePersianDatetimePicker from "vue-persian-datetime-picker";
Vue.component("date-picker", VuePersianDatetimePicker);

import VueMask from "v-mask";
Vue.use(VueMask);

// Sentry
// import * as Sentry from "@sentry/vue";
// import { Integrations } from "@sentry/tracing";

// Sentry.init({
//   Vue,
//   dsn:
//     "https://b652f0ae70ab4931a23905a808293e52@o665993.ingest.sentry.io/5766315",
//   integrations: [new Integrations.BrowserTracing()],

//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0
// });

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App)
}).$mount("#app");
